import { Box } from "@outschool/backpack";
import {
  SavedSearchFilters,
  SearchFilters as SearchFiltersType
} from "@outschool/gql-backend-generated";
import { useSession } from "@outschool/ui-auth";
import { useMobileSearchBar } from "@outschool/ui-components-website";
import { Container } from "@outschool/ui-legacy-component-library";
import { Screen } from "@outschool/ui-utils";
import React, { useEffect, useRef, useState } from "react";

import { CategoryDesktopFilters } from "./CategoryDesktopFilters";
import { CategoryListingsFiltersMobile } from "./CategoryListingsFiltersMobile";
import { CategorySortBy } from "./CategorySortBy";
import { filtersToShowDefault, getFiltersToShow } from "./FiltersToShow";

type CategoryListingsFiltersProps = {
  updateListings: (payload: SearchFiltersType) => void;
  resetSearchFilters?: () => void;
  searchFilters: SearchFiltersType;
  preSetFilters?: SavedSearchFilters;
  isCuratedCategoryFilter?: boolean;
};

export const CategoryListingsFilters = ({
  updateListings,
  resetSearchFilters,
  searchFilters,
  preSetFilters,
  isCuratedCategoryFilter = false
}: CategoryListingsFiltersProps) => {
  const { verticalOffset } = useMobileSearchBar();
  const isMobile = Screen.useIsTablet();
  const containerRef = useRef();

  const [filtersToShow, setfiltersToShow] = useState(filtersToShowDefault());

  const { currentUser } = useSession();

  useEffect(() => {
    const childrenAges =
      currentUser && currentUser.children
        ? currentUser.children.map(el => el.age)
        : [];
    // @ts-ignore TS(2345): Argument of type 'SavedSearchFilters | undefined' ... Remove this comment to see the full error message
    setfiltersToShow(getFiltersToShow(preSetFilters, childrenAges));
  }, [preSetFilters, currentUser]);

  return (
    <Box
      sx={{
        top: verticalOffset,
        position: "sticky",
        backgroundColor: "common.white",
        zIndex: 2,
        paddingY: "8px"
      }}
    >
      <Container>
        <Box flex sx={{ gap: "8px", marginTop: "1px" }} ref={containerRef}>
          {isMobile ? (
            <CategoryListingsFiltersMobile
              filters={searchFilters}
              setFilters={updateListings}
              filtersToShow={filtersToShow}
              isCuratedCategoryFilter={isCuratedCategoryFilter}
            />
          ) : (
            <CategoryDesktopFilters
              updateSearchFilters={updateListings}
              searchFilters={searchFilters}
              resetSearchFilters={resetSearchFilters}
              filtersToShow={filtersToShow}
            />
          )}
          <CategorySortBy
            searchFilters={searchFilters}
            updateListings={updateListings}
            isMobile={isMobile}
          />
        </Box>
      </Container>
    </Box>
  );
};
